/** Colores base nativos de Ionic */
export const IONIC_DEFAULT_COLORS = [
    'mediumV1',
    'tptradicional',
    'tpplus',
    'tpdesarrollo',
    'tpteleventa',
    'tponpremise',
    'tpcta',
    'tpctaV2',
    'tpctaV3',
    'cerulean-disable',
    'lightblue',
    'translucidWhite',
    'gradient-blue-demon',
    'sunflower',
    'sunflower2',
    'stairs',
    'orange',
    'bluegray',
    'darkish-blue',
    'correct',
    'correct2',
    'darkblue',
    'white',
    'gray',
    'grayContrast',
    'grayDemon',
    'transparent',
    'back-game',
    'leaderboard',
    'gray-blue',
    'white-grad',
    'cadet-grey',
    'paradise-pink',
    'dark-electric-blue',
    'cherry',
    'gradient-blue',
    'status-icon-enable',
    'status-icon-disable',
    'datetime',
    'purple',
    'pink',
];

/** Tus colores personalizados declarados en variables.scss */
export const CUSTOM_THEME_COLORS = [
    'getm-primary-default',
    'getm-primary-hover',
    'getm-primary-pressed',
    'getm-primary-selected',
    'getm-secondary-default',
    'getm-secondary-hover',
    'getm-secondary-pressed',
    'getm-secondary-selected',
    'getm-neutral-dark',
    'getm-neutral-light',
    'getm-neutral-white',
    'getm-neutral-gray',
    'getm-neutral-hover',
    'getm-neutral-pressed',
    'getm-neutral-selected',
    'getm-disabled-default',
    'getm-disabled-dark',
    'getm-disabled-light',
    'getm-information-default',
    'getm-information-dark',
    'getm-information-light',
    'getm-success-default',
    'getm-success-light',
    'getm-success-dark',
    'getm-warning-default',
    'getm-warning-light',
    'getm-warning-dark',
    'getm-error-default',
    'getm-error-light',
    'getm-error-dark',
    'getm-category-gana-mas',
    'getm-category-gana-mas-light',
    'getm-category-gana-mas-dark',
    'getm-category-promociones',
    'getm-category-promociones-light',
    'getm-category-especiales-del-mes',
    'getm-category-especiales-del-mes-light',
    'getm-category-especiales-del-mes-dark',
    'getm-category-los-mas-vendido',
    'getm-category-los-mas-vendido-light',
    'getm-category-los-mas-vendido-dark',
    'getm-category-pedido-sugerido',
    'getm-category-pedido-sugerido-light',
    'getm-category-pedido-sugerido-dark',
    'getm-background-light-blue',
    'getm-background-dark',
    'getm-background-white',
    'getm-background-gray',
    'deadline-status-bg',
];

/** Unión de todos los colores válidos para la aplicación */
export const ALL_ALLOWED_COLORS = [...IONIC_DEFAULT_COLORS, ...CUSTOM_THEME_COLORS];

export const ALLOWED_CSS_PROPS = [
    'font-weight',
    'text-decoration',
    'font-size',
    'font-style',
    'letter-spacing',
    'text-transform',
    'vertical-align',
    'margin',
    'margin-left',
    'margin-right',
    'margin-top',
    'margin-bottom',
    'padding',
    'padding-left',
    'padding-right',
    'padding-top',
    'padding-bottom',
];

